<template>
  <el-row class="container-card el-row">
    <Channels />
  </el-row>
</template>

<script>
import Channels from '../components/Table'

export default {
  components: {
    Channels
  }
}
</script>
